<template>
    <div id="tab-info" class="tab">
        <div class="profile-info-grid">
            <div class="profile-photo">
                <div class="sub-box"><img :src="employee.image" alt=""></div>
                <span @click="editProfile" class="edit-profile-btn js-open-popup">Редактировать профиль</span>
            </div>
            <div class="profile-contacts">
                <div class="col">
                    <phone-item v-for="(phone, index) in employee.phones" :key="index" :phone="phone"></phone-item>
                    <p class="font-icon-email outside-icon" v-for="(mail, index) in employee.mails"
                       :key="genKey(index)"><a :href="'mailto:' + mail">{{mail}}</a></p>
                    <p class="outside-icon">{{(employee.groupId === 2 ? 'В агентстве с' : 'Стажируется с ') + customFormat(employee.dateOfEmployment)}}</p>
                </div>
                <div class="col">
                    <p class="font-icon-questionnaire outside-icon">
                        <a href @click.prevent="getTest">Анкета</a>
                    </p>
                    <p class="font-icon-test outside-icon">
                        <a href @click.prevent="getQuestionnaire">Тест</a>
                    </p>
                </div>
            </div>
            <span @click="editProfile" class="edit-profile-btn js-open-popup">Редактировать профиль</span>
        </div>
    </div>
</template>

<script>

    import {mapActions, mapMutations} from "vuex"
    import TestView from "./TestView";
    import QuestionnaireView from "./QuestionnaireView";
    import PhoneItem from "./PhoneItem";
    import EditProfileForm from "./EditProfileForm";
    import moment from 'moment'

    export default {
        name: 'current-employee-info',
        components: {
            PhoneItem
        },
        data() {
            return {
                options: {
                    values: ["Ожидает проверки","Заполнил анкету","Создал пароль"],
                },
            }
        },
        props: {
            employee: Object,
        },
        methods: {
            ...mapActions([
                'switchPopup'
            ]),
            ...mapMutations([
                'setPopupComponent',
            ]),
            getQuestionnaire() {
                this.setPopupComponent(QuestionnaireView);
                this.switchPopup(true)
            },
            getTest() {
                this.setPopupComponent(TestView);
                this.switchPopup(true)
            },
            editProfile() {
                this.setPopupComponent(EditProfileForm);
                this.switchPopup(true)
            },
            customFormat(date) {
                if(date instanceof Date) {
                    return moment(date).format('DD/MM/YYYY');
                }
                return date ? date : '-'
            },
        },

    }
</script>

<style scoped>
    .tab {
        display: block
    }
</style>
